/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import IconHand from './IconHand';
import css from './V360Tutorial.scss';

const classes = {
	tutorial: css.v360Tutorial,
	gesture: css.v360TutorialGesture,
	hand: css.v360TutorialHand,
	isHidden: css.isHidden,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	mobile: PropTypes.bool,
	display: PropTypes.bool,
};

const defaultProps = {
	className: '',
	classes,
	mobile: true,
	display: false,
};

export const V360Tutorial = ({
	className,
	classes,
	mobile,
	display,
	...props
}) => {
	return (
		<div
			{...props}
			aria-hidden={true}
			className={cls(classes.tutorial, className, {
				[classes.isHidden]: !display,
			})}>
			<div className={classes.gesture}>
				<IconHand
					className={classes.hand}
					width={50}
					height={50}
				/>
			</div>
		</div>
	);
};

V360Tutorial.displayName = 'V360Tutorial';
V360Tutorial.propTypes = propTypes;
V360Tutorial.defaultProps = defaultProps;
export default V360Tutorial;
